import { Select } from '@mnd-frontend/ui/publish/components';
import styled from 'styled-components';

const Wrapper = styled.div``;

const FilterSelect = ({
  show,
  name,
  label,
  onChange,
  options,
  value,
  skipMargin,
}: {
  show?: boolean;
  name: string;
  onChange: (name: string, value: string) => void;
  options: { value: string; label: string }[];
  value?: string;
  label: string;
  skipMargin?: boolean;
}) => {
  return show ? (
    <Wrapper>
      <Select
        label={label}
        options={options}
        onChange={v => v && onChange(name, v)}
        value={value}
        skipMargin={skipMargin}
      />
    </Wrapper>
  ) : null;
};

export default FilterSelect;
